import { render, staticRenderFns } from "./ReportProductSales.vue?vue&type=template&id=c08e3a66"
import script from "./ReportProductSales.vue?vue&type=script&lang=js"
export * from "./ReportProductSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports